/**
 * Created by robert.lavoie on 6/20/17.
 */

// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMathPipesModule } from 'ngx-pipes';
import { SwiperModule, SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: 'horizontal',
  spaceBetween: 10,
  slidesPerView: 1,
  centeredSlides: true
};

// Components
import {
  JobsSearchComponent,
  JobsSearchResultsListViewComponent,
  JobsSearchResultsMapViewComponent,
  JobSearchFiltersMobileMenuComponent,
  JobSearchFiltersComponent,
  JobsSearchResultsSlider,
  JobsSearchResultsJobListing,
  MapOverlayComponent
} from '../../components';

// Services
import { JobsSearchService, LocationSearchService, GeoLocationService, BrowserService } from '../../services';
import { ScriptService } from 'snagajob/src/services/scripts/script.service';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    NgMathPipesModule,
    SwiperModule
  ],
  declarations: [
    JobsSearchComponent,
    JobsSearchResultsListViewComponent,
    JobsSearchResultsMapViewComponent,
    JobSearchFiltersMobileMenuComponent,
    JobSearchFiltersComponent,
    JobsSearchResultsSlider,
    JobsSearchResultsJobListing,
    MapOverlayComponent
  ],
  providers: [JobsSearchService, LocationSearchService, GeoLocationService, ScriptService, BrowserService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  exports: [
    JobsSearchComponent,
    JobsSearchResultsListViewComponent,
    JobsSearchResultsMapViewComponent
  ]
})
export class JobsSearchModule {}
